<template>
  <div
    :class="{
      'w-full h-full left-0 top-0 bg-black bg-opacity-50 backdrop-blur-sm absolute z-30':
        dailyModalIsOpen,
    }"
    @click="hanldeDailyModal"></div>
  <span class="h-full relative flex justify-center">
    <img
      src="~/assets/svg/dailyClaim.svg"
      alt="daily claim"
      :class="{
        'w-6 h-6 lg:w-8 lg:h-8 cursor-pointer': true,
        'z-30 scale-105 transition-all': dailyModalIsOpen,
      }"
      @click="hanldeDailyModal"
    />
    <div
      v-if="dailyModalIsOpen"
      class="w-[32rem] h-auto z-30 absolute border-2 rounded bg-graybase border-primary flex flex-col p-2 gap-4 bottom-0 translate-y-[calc(100%+2rem)]"
    >
      <div class="flex flex-col items-center">
        <div class="flex justify-between items-center w-full pl-4 pr-4">
          <div class="flex items-center justify-start gap-1 min-w-24">
            <img src="~/assets/svg/fire_streak.svg" alt="fire" class="w-6 h-6 md:w-8 md:h-8" />
            <Typography size="main-xl-num">{{ totalStreak }}</Typography>
          </div>
          <Typography size="main-md" class="mx-auto">Daily streak</Typography>
          <div class="flex items-center min-w-24">
            <span class="flex flex-col" v-if="state === 'disabled'">
              <span class="flex items-center h-5">
                <Typography
                  size="secondary-sm"
                  class="!font-light !text-[0.6rem] text-center"
                  >Next claim in:</Typography
                >
              </span>
              <span class="flex items-center h-5">
                <streak-countdown :endDate="streakEndsAt" @timer-end="timerEnd" />
              </span>
            </span>
            <span class="flex flex-col" v-else-if="state === 'claim'">
              <span class="flex items-center h-5">
                <Typography
                  size="secondary-sm"
                  class="!font-light !text-[0.6rem] text-center"
                  >Claim now:</Typography
                >
              </span>
              <span class="flex items-center h-5">
                <streak-countdown :endDate="claimStreakEndsAt" @timer-end="timerEnd" />
              </span>
            </span>
          </div>
        </div>
      </div>


      <div class="grid grid-cols-4 gap-2">
        <div
          v-for="weekStreak in weekStreaks"
          :key="weekStreak.day"
          class="flex flex-col gap-2 rounded bg-neutral-900 items-center justify-center p-2 aspect-square relative"
          :class="{
            'opacity-60': weekStreak.opacity
          }"
        >
          <img
            v-if="weekStreak.claimed"
            src="~/assets/svg/correct.svg"
            alt="correct"
            class="w-3 h-3 absolute top-0 left-0 cursor-pointer m-2"
          />
          <span class="h-6 flex items-center">
            <Typography size="main-l-num"
                        class="text-primary">Day {{ weekStreak.day }}</Typography>
          </span>
          <span class="flex items-center">
            <img
              src="~/assets/svg/troncos.svg"
              alt="claim"
              class="w-5 h-5 md:w-8 md:h-8 cursor-pointer"
            />
            <span class="flex item gap-1" v-if="weekStreak.day === 1">
              <Typography size="main-xl-num">5</Typography>
            </span>
            <span class="flex item gap-1" v-if="weekStreak.day === 2">
              <Typography size="main-xl-num">5</Typography>
            </span>
            <span class="flex item gap-1" v-if="weekStreak.day === 3">
              <Typography size="main-xl-num">5</Typography>
            </span>
            <span class="flex item gap-1" v-if="weekStreak.day === 4">
              <Typography size="main-xl-num">10</Typography>
            </span>
            <span class="flex item gap-1" v-if="weekStreak.day === 5">
              <Typography size="main-xl-num">10</Typography>
            </span>
            <span class="flex item gap-1" v-if="weekStreak.day === 6">
              <Typography size="main-xl-num">15</Typography>
            </span>
            <span class="flex item gap-1" v-if="weekStreak.day === 7">
              <Typography size="main-xl-num">20</Typography>
            </span>
          </span>
        </div>
        <button class="self-end"
                @click="handleClaim()"
                :disabled="state === 'disabled'"
                :class="{
                  'bg-primary': state === 'claim',
                  'bg-primary opacity-50': state === 'disabled',
                }">
          <Typography size="main-md">Claim</Typography>
        </button>
      </div>
    </div>
  </span>
  <Modal :value="modalRewardIsOpen" @close="modalRewardIsOpen = false">
    <div class="flex flex-col gap-8 items-center">
      <div class="flex items-center justify-center gap-2">
        <img src="~/assets/svg/fire_streak.svg" alt="" class="w-14 h-14" />
        <span class="h-12"><Typography size="main-xl-num">{{createdStreak}}</Typography></span>
      </div>
      <Typography size="main-xl" class="text-center">Keep it going!</Typography>
      <Typography class="text-center">Congrats on your {{createdStreak}} day streak! Come back
        tomorrow to continue building it up</Typography>
      <button
        @click="modalRewardIsOpen = false"
        class="rounded bg-primary w-full max-w-sm font-bold items-center justify-center flex"
      >
        <span class="h-12 flex justify-center items-center">
          <Typography size="main-l">Nice </Typography>
        </span>
      </button>
    </div>
  </Modal>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import Typography from "./common/Typography.vue"
import Modal from "@/components/modal.vue"
import StreakCountdown from "@/components/streak-countdown.vue"
import { useStreakStore } from "../stores/useStreakStore"
import { useAuthStore } from "../stores/useAuthStore"
import { useModalsStore } from "../stores/useModalsStore"
import { cmsStore } from "../stores/cmsStore"
import { DateTime } from 'luxon'

const streakStore = useStreakStore()
const authStore = useAuthStore()
const modalsStore = useModalsStore()
const cms = cmsStore()

const modalRewardIsOpen = ref(false)
const dailyModalIsOpen = ref(false)
const createdStreak = ref(0)
const disableButton = ref(true)
const totalStreak = computed(() => streakStore.getTotalStreak)
const weekStreaks =computed(() => streakStore.getWeekStreaks)
const streakEndsAt = computed(() => add24hToPublishDate(streakStore.getStreakEndsAt))
const claimStreakEndsAt = computed(() => add48hToPublishDate(streakStore.getStreakEndsAt))
const state = ref('disabled')

const checkDisableButton = () => {
  if (!streakEndsAt.value) {

    return false; // Habilitar el botón si streakEndsAt es null
  }
  const now = new Date();
  const target = new Date(streakEndsAt.value);
  return now <= target; // Deshabilitar si ahora es antes de la fecha objetivo
}

const hanldeDailyModal = () => {
  if (!authStore.isAuthenticated) {
    return modalsStore.openModal('LOGIN')
  }
  dailyModalIsOpen.value = !dailyModalIsOpen.value
}

const handleClaim = () => {
  if (!authStore.isAuthenticated) {
    return modalsStore.openModal('LOGIN')
  }
  streakStore
    .requestClaimStreak()
    .then((response) =>{
      streakStore
        .getUserStreaks()
        .then(() => {
          cms.updateNotifications()
        })
      createdStreak.value = response.streak
      modalRewardIsOpen.value = !modalRewardIsOpen.value
    })
}

const checkResetStreak = () => {
  streakStore
    .requestCheckResetStreak()
    .then(() => {
      streakStore
        .getUserStreaks()
        .then(() => {
          cms.updateNotifications()
        })
    })
}

function add24hToPublishDate(publishDate) {
  const dt = DateTime.fromISO(publishDate, { zone: 'Europe/Dublin' });
  const newDt = dt.plus({ hours: 24 });
  return newDt.toISO();
}

function add48hToPublishDate(publishDate) {
  const dt = DateTime.fromISO(publishDate, { zone: 'Europe/Dublin' });
  const newDt = dt.plus({ hours: 48 });
  return newDt.toISO();
}

const timerEnd = () => {
  const now = new Date();
  if (now <= new Date(streakEndsAt.value)) {
    state.value = 'disabled';
    disableButton.value = true;
  } else if (now <= new Date(claimStreakEndsAt.value)) {
    state.value = 'claim';
    disableButton.value = false;
  } else {
    state.value = 'disabled';
    disableButton.value = true;
  }
}

onMounted(() => {
  streakStore
    .getUserStreaks()
    .then()

  timerEnd()

  const interval = setInterval(() => {
    timerEnd()
    const now = new Date()
    if (authStore.isAuthenticated && claimStreakEndsAt.value && now >= new Date(claimStreakEndsAt.value)) {
      checkResetStreak()
    }
  }, 1000)

  onUnmounted(() => {
    clearInterval(interval)
  })
})
</script>